import { Toaster as ToasterComponent } from './components/Toaster';
import { useToast as useToastHook } from './hooks/useToast';

export const Toaster = ToasterComponent;
export const useToast = useToastHook;
